import { createI18n, I18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

export const initI18n = (locale: string = 'en'): I18n => {
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale: 'en',
    messages: messages,
  });
};
